/* eslint-disable no-undef */
import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/v1`,
  headers: {
    name: 'Content-Type',
    value: 'application/json',
  },
});

export const axiosInstanceV2 = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/v2`,
  headers: {
    name: 'Content-Type',
    value: 'application/json',
  },
});

export const axiosDocumentsInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/docs`,
  headers: {
    name: 'Content-Type',
    value: 'application/json',
  },
});
